import CustomerModal from '@/components/customers/CustomerModal.jsx';

/**
 * Kept as a compatibility adapter for existing entry points.
 * All quick client creation now uses the same validated AFIP/DNI flow.
 */
export default function QuickCreateClienteModal({ isOpen, onClose, onComplete, eventualMode = false, initialCapture = false, excludeId = null }) {
  return (
    <CustomerModal
      isOpen={isOpen}
      onClose={onClose}
      onSelect={onComplete}
      initialTab="crear"
      eventualMode={eventualMode}
      initialCapture={initialCapture}
      excludeId={excludeId}
    />
  );
}
